import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedInput = _resolveComponent("FriedInput");
    const _component_FriedSelect = _resolveComponent("FriedSelect");
    const _directive_autofocus = _resolveDirective("autofocus");
    return (_openBlock(), _createElementBlock("form", {
        class: "create-entity-container",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
        _withDirectives(_createVNode(_component_FriedInput, {
            modelValue: _ctx.formData.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formData.name) = $event)),
            modelModifiers: { trim: true },
            class: "create-entity-input",
            "data-external": "create-entity-company-name-input",
            label: _ctx.$t('company-name'),
            "help-message": _ctx.$t('you-can-always-change-the-company-name-later'),
            "error-message": _ctx.formErrorName,
            onBlur: _ctx.validateForm
        }, null, 8, ["modelValue", "label", "help-message", "error-message", "onBlur"]), [
            [_directive_autofocus]
        ]),
        _createVNode(_component_FriedSelect, {
            class: "create-entity-input",
            options: _ctx.countryItems,
            "model-value": _ctx.selectedCountry,
            label: _ctx.$t('country'),
            "option-label": "labelWithFlag",
            searchable: true,
            "empty-state-text": _ctx.$t('no-items-found'),
            "help-message": _ctx.$t('connected-to-your-sendouts-currency-and-timezone'),
            "onUpdate:modelValue": _ctx.handleCountryChange
        }, null, 8, ["options", "model-value", "label", "empty-state-text", "help-message", "onUpdate:modelValue"]),
        _createVNode(_component_FriedSelect, {
            class: "create-entity-input",
            options: _ctx.datacenterItems,
            "model-value": _ctx.selectedDatacenter,
            label: _ctx.$t('datacenter'),
            "option-label": "name",
            "empty-state-text": _ctx.$t('no-items-found'),
            "help-message": _ctx.$t('the-physical-location-of-your-document-storage'),
            "onUpdate:modelValue": _ctx.handleDatacenterChange
        }, null, 8, ["options", "model-value", "label", "empty-state-text", "help-message", "onUpdate:modelValue"])
    ], 32));
}
